
import { Options, Vue } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { maska } from 'maska'
import { constant } from '@/utils/constants'
import { IImageUrlSize, IRichMenuContent, IRichMenuTemplateCompact } from '@/utils/types'
import { NumberUtils } from '@/utils/number'
import SettingTappableModal from '@/components/tappable-area/SettingTappableModal.vue'
import RichMenuAssetModal from '@/components/rich-menus/RichMenuAssetModal.vue'
import cloneDeep from 'lodash/cloneDeep'
import { ObjectUtils } from '@/utils/objects'
import CopyMenuModal from '@/components/rich-menus/CopyMenuModal.vue'
import { now } from '@/utils/datetime'
import { UserModel } from '@/models/user-model'

@Options({
  components: {
    CopyMenuModal,
    RichMenuAssetModal,
    SettingTappableModal,
  },
  directives: { maska },
  emits: ['update:modelValue', 'update:submitMenu', 'update:refetchMenu', 'onPreview'],
})
export default class RichMenuSelector extends Vue {
  @Prop({ default: [] })
  modelValue!: IRichMenuContent[]

  selectedMenu!: IRichMenuContent
  defaultSize: IImageUrlSize = {}
  modalTappableAreasVisible = false
  selectedTemplate: IRichMenuTemplateCompact = {}
  modalMenuAssetVisible = false
  originalMenus: IRichMenuContent[] = []
  modalCopyMenuVisible = false
  copyMenuLoading = false

  get userInfo(): UserModel {
    return this.$store.getters.userInfo
  }

  get value() {
    return this.modelValue
  }

  set value(value: IRichMenuContent[]) {
    this.$emit('update:modelValue', value)
  }

  get isSwitchMenu() {
    return this.value.length > 1
  }

  get isChanged() {
    return Object.keys(this.originalMenus).length && ObjectUtils.isDifference(this.value, this.originalMenus)
  }

  handleSelectedMenu() {
    let width = 0
    let height = 0
    if (!this.selectedMenu) {
      return
    }
    if (this.selectedMenu.image_width) {
      width =
        this.selectedMenu.image_width * (constant.RICH_MENU_IMAGE.IMAGE_DEFAULT_SIZE / this.selectedMenu.image_width)
    }
    if (this.selectedMenu.image_height && this.selectedMenu.image_width) {
      height =
        this.selectedMenu.image_height * (constant.RICH_MENU_IMAGE.IMAGE_DEFAULT_SIZE / this.selectedMenu.image_width)
    }

    this.defaultSize = {
      width,
      height,
      image_url: this.selectedMenu.image_url,
    }
  }

  onSettingMenu(index) {
    if (this.value) {
      this.selectedMenu = this.value[index]
      this.handleSelectedMenu()
    }
    this.modalTappableAreasVisible = true
  }

  handleEditMenu(index: number) {
    if (this.value) {
      this.selectedMenu = this.value[index]
      if (this.selectedMenu.selected_template) {
        this.selectedTemplate = this.selectedMenu.selected_template
        this.selectedTemplate.tappable_area = this.selectedMenu.tappable_area
      } else {
        this.selectedTemplate = {}
      }
      this.modalMenuAssetVisible = true
    }
  }

  handleAddMenu(): void {
    const menu: IRichMenuContent = {
      label: '',
      rich_menu_alias_id: NumberUtils.uniqueId(),
      size: {
        width: constant.RICH_MENU_IMAGE.MAX_IMAGE_WIDTH,
        height: constant.RICH_MENU_IMAGE.MAX_IMAGE_HEIGHT,
      },
      tappable_area: [],
      image_url: '',
      created_at: now(constant.DATETIME_FORMAT),
      created_by: this.userInfo.display_name,
    }
    this.selectedTemplate = {}
    this.selectedMenu = menu
    this.modalMenuAssetVisible = true
  }

  handleDeleteMenu(index: number): void {
    if (this.value) {
      this.value.splice(index, 1)
      this.selectedTemplate = {}
    }
  }

  onCloseTappableAreasModal() {
    this.modalTappableAreasVisible = false
  }

  onCloseMenuAssetModal() {
    this.modalMenuAssetVisible = false
  }

  onCloseCopyMenuModal() {
    this.modalCopyMenuVisible = false
  }

  onSubmitTemplate(data) {
    this.selectedMenu = data
    this.handleSelectedMenu()
    this.modalTappableAreasVisible = true
  }

  onSubmitMenu(data) {
    this.selectedMenu = data
    const index = this.value.findIndex((item) => item.rich_menu_alias_id === this.selectedMenu.rich_menu_alias_id)
    if (index !== -1) {
      this.value[index] = this.selectedMenu
    } else {
      this.value.push(this.selectedMenu)
    }
    this.modalMenuAssetVisible = false
  }

  onPreview(index: number) {
    if (this.value) {
      this.selectedMenu = this.value[index]
      this.$emit('onPreview', this.selectedMenu)
    }
  }

  onCopy(index: number, type: string) {
    console.log('Copying menu:', index, type)
    if (this.value) {
      const menu = cloneDeep(this.value[index])
      menu.rich_menu_alias_id = NumberUtils.uniqueId()
      menu.label = this.value[index].label + ' copy'
      if (type === 'copy') {
        this.value.push(menu)
      } else {
        this.selectedMenu = menu
        this.modalCopyMenuVisible = true
      }
    }
  }

  onSubmitDraftMenu() {
    this.copyMenuLoading = true
    this.$emit('update:submitMenu')
  }

  onRefetchMenu(data) {
    this.$emit('update:refetchMenu', data)
  }

  updateOriginalMenus() {
    this.originalMenus = cloneDeep(this.value)
    this.copyMenuLoading = false
  }

  mounted() {
    setTimeout(() => {
      this.updateOriginalMenus()
    }, 500)
  }
}
